class BestioCartConfirmation extends HTMLElement {
  connectedCallback() {
    if (this._connected) return;
    this._connected = true;
    this._dialog = this.querySelector('.bestio-cart-confirmation__dialog');
    this._lastFocused = null;
    this._onOpen = event => this.open(event.detail?.variantId);
    this._onKeydown = event => {
      if (event.key === 'Escape') this.close();
    };
    this._onClick = event => {
      if (event.target.closest('[data-confirmation-close]')) this.close();
      const add = event.target.closest('[data-confirmation-add]');
      if (add && !add.disabled) this.addPieces(add);
    };
    document.addEventListener('cart:add-confirmation:open', this._onOpen);
    this.addEventListener('keydown', this._onKeydown);
    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:add-confirmation:open', this._onOpen);
    this.removeEventListener('keydown', this._onKeydown);
    this.removeEventListener('click', this._onClick);
    this._connected = false;
  }

  open(variantId) {
    const items = [...this.querySelectorAll('[data-added-variant]')];
    const selected = items.find(item => item.dataset.addedVariant === String(variantId));
    items.forEach(item => { item.hidden = item !== selected; });
    const relationPanels = [...this.querySelectorAll('[data-relation-variant]')];
    const selectedRelations = relationPanels.find(panel => panel.dataset.relationVariant === selected?.dataset.addedVariant);
    relationPanels.forEach(panel => { panel.hidden = panel !== selectedRelations; });
    const relationsWrapper = this.querySelector('[data-confirmation-relations]');
    if (relationsWrapper) relationsWrapper.hidden = !selectedRelations?.querySelector('[data-confirmation-content]');
    if (!selected) return;
    this._lastFocused = document.activeElement;
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bestio-cart-confirmation-open');
    window.requestAnimationFrame(() => this._dialog?.focus({preventScroll: true}));
  }

  /**
   * Adds the pieces to the next quantity-discount tier. xCartHelper renders the cart sections again and opens the
   * confirmation of the same variant with the new count; the button stays disabled until then.
   */
  addPieces(button) {
    const id = Number(button.dataset.confirmationAdd);
    const quantity = Number(button.dataset.quantity);
    if (!id || !quantity || !window.xCartHelper?.addItems) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    window.xCartHelper.addItems([{id, quantity}]);
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bestio-cart-confirmation-open');
    this._lastFocused?.focus?.({preventScroll: true});
  }
}

if (!customElements.get('bestio-cart-confirmation')) {
  customElements.define('bestio-cart-confirmation', BestioCartConfirmation);
}
